export const buildDefaultHeaders = (getState) => {
  const { token } = getState().auth; // <-- токен сохраняется в Redux после логина

  return {
    headers: {
      'Content-Type': 'application/json',
      // убираем Access-Control-Allow-Origin — он должен быть только на сервере
      ...(token ? { Authorization: `Bearer ${token}` } : {}), // ✅ правильный формат
    },
  };
};


export const arrayBufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = []
        .slice
        .call(new Uint8Array(buffer));

    bytes.forEach((b) => binary += String.fromCharCode(b));

    const base64Flag = 'data:image/jpeg;base64,';
    const imageStr = window.btoa(binary);

    return base64Flag + imageStr;
};

